import nativeApi from "./nativeApi";

export default function goToUrl(url) {
  nativeApi.invoke("createWebView", { url }).catch(() => {
    location.href = url;
  });
}
